import { InjectionToken } from '@angular/core';

export const SHEET_VIEW_OPEN = new InjectionToken<boolean>('SHEET_VIEW_OPEN');
